import { Box, Text } from '@chakra-ui/react';
import quote from '../../public/images/resources/quote.svg';

export default function Blockquote({ text, author }: { text: string; author: string }) {
  return (
    <Box
      as="blockquote"
      maxW="61.125rem"
      margin={{ base: '5rem auto 3.2rem', lg: '6.25rem auto 4rem' }}
      position="relative"
      textAlign="center"
      color="#415f7c"
      _before={{
        content: `""`,
        position: 'absolute',
        top: '-2rem',
        left: '0',
        right: '0',
        ml: 'auto',
        mr: 'auto',
        w: '1.375rem',
        h: '1.125rem',
        bgImage: `url(${quote.src})`,
        bgRepeat: 'no-repeat',
        bgSize: 'cover',
      }}
    >
      <Text
        fontSize={{ base: '1.3rem', lg: '1.625rem' }}
        lineHeight={{ base: '1.7rem', lg: '2.125rem' }}
        fontWeight="700"
        mb="1rem"
      >
        {text}
      </Text>
      <Box
        as="cite"
        fontWeight="600"
        fontSize={{ base: '0.9rem', lg: '1.125rem' }}
        lineHeight={{ base: '1.3rem', lg: '1.625rem' }}
      >
        {author}
      </Box>
    </Box>
  );
}
